var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg1Overviewsvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M15.523 8.941H8.544l4.648 4.648c.178.178.47.192.653.02a7.044 7.044 0 002.15-4.143.471.471 0 00-.472-.525zm-.465-1.906A7.076 7.076 0 008.494.472.473.473 0 008 .948V7.53h6.582a.473.473 0 00.476-.494zm-8.47 1.906V1.962a.471.471 0 00-.524-.472 7.054 7.054 0 00-6.06 7.227c.128 3.769 3.373 6.86 7.144 6.812a7.004 7.004 0 003.978-1.295.467.467 0 00.046-.708L6.588 8.94z",
    fill: "#9FA2B4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1Overviewsvg);
export default __webpack_public_path__ + "static/media/_1Overviewsvg.15938429827399a1734864b32fc5803d.svg";
export { ForwardRef as ReactComponent };